export default __webpack_public_path__ + "static/media/Imagen3.0a9cd512.svg";